import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Checkbox } from '../../../../../components/Checkbox';
import { Dropdown } from '../../../../../components/Dropdown';
import { ManualDropdown } from '../../../../../components/ManualDropdown';
import { FormField } from '../../../../../components/FormFields';
import { DecoratorLabel, Input } from '../../../../../components/Input';
import { Loader } from '../../../../../components/Loader';
import { deleteVehicleProperty, initiateNewVehicleValue, setNewVehicleValue } from '../../../actions';
import { selectNewVehicle, selectNewVehicleValue, selectVehicle } from '../../../selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { selectWork } from '../../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../constants';
import cn from 'classnames';
import CheckboxComponent from '../../../../../containers/App/Components/Checkbox/Checkbox';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import styles from './Fields.module.css';

dayjs.extend(customParseFormat);
const DROPDOWN_OPTIONS = {};

const MANUAL_DROPDOWN_OPTIONS = {
  vehicleType: ['passengerCar', 'deliveryVan', 'camperVan', 'motorcycle'],
};

const Container = styled.div`
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  isCheckbox() {
    return ['is_imported'].indexOf(this.props.type) > -1;
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  isManualDropbox() {
    return this.props.type in MANUAL_DROPDOWN_OPTIONS;
  }

  wrap(children) {
    const containsCheckbox = element => {
      if (React.isValidElement(element) && element.props) {
        return typeof element.props.className === 'string' && element.props.className.includes('checkbox');
      }
      return false;
    };

    const isCheckboxComp = React.Children.toArray(children).some(child => containsCheckbox(child));

    if (isCheckboxComp) {
      return <div>{children}</div>;
    } else {
      return (
        <div>
          <label className="form-label">{this.formFieldLabel()}</label>
          {children}
        </div>
      );
    }
  }

  formFieldLabel() {
    if (this.isCheckbox()) return null;
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${this.props.type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.props.value);
    return (
      <div className={styles.container}>
        <Dropdown
          className={styles.dropdown}
          options={options}
          value={value}
          onChange={pair => this.props.setValue(pair.value)}
        />
      </div>
    );
  }

  manualDropdown() {
    const vals = MANUAL_DROPDOWN_OPTIONS[this.props.type];
    return (
      <ManualDropdown
        model={'vehicle'}
        key={this.props.type}
        type={this.props.type}
        editable={true}
        deletable={this.props.vehicle && this.props.vehicle[this.props.type]}
        options={vals}
        onChange={value => this.props.setValue(value)}
        onReset={() => this.props.setValue('')}
        onDeleteValue={value =>
          this.props.deleteProperty(this.props.values?.id, this.props.type, result => {
            if (result === true) {
              this.props.setValue('');
            }
          })
        }
        onManual={value => {
          return this.props.setValue(value, this.props.type + '_manual');
        }}
      />
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;
    if (this.isCheckbox()) {
      return (
        <CheckboxComponent
          className="checkbox"
          label={this.lbl(`vehicle.property.${this.props.type}`)}
          checked={this.props.value === '1'}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';
            return this.props.setValue(value);
          }}
        />
      );
    }

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isManualDropbox()) {
      return this.manualDropdown();
    }

    switch (this.props.type) {
      case 'cyllinder_capacity':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'number_of_cillinders':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'number_of_cillinders':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );

        
      case 'acceleration_0_100':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>sec</div>
          </div>
        );
      case 'topspeed':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>km/h</div>
          </div>
        );
      case 'torque':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>Nm</div>
          </div>
        );
      case 'wheelbase':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>cm</div>
          </div>
        );
      case 'vehicle_length':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>cm</div>
          </div>
        );
      case 'vehicle_width':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>cm</div>
          </div>
        );
      case 'vehicle_height':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'loadingspace':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>liter</div>
          </div>
        );
      case 'tank_contents':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>liter</div>
          </div>
        );
      case 'tanks_capacity':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>liter</div>
          </div>
        );
      case 'weight_driveready':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'empty_weight':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'max_allowed_weight':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'technical_max_weight_vehicle':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'allowed_max_weight_vehicle':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'warranty_type':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'warranty_period':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'number_of_seats':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'interior_color':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'interior_type':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'number_of_doors':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'primary_exterior_color_factory_name':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'secondary_exterior_color_factory_name':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'number_of_gears':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'number_of_axles':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'power_axle':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'placecode_as':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'trackwidth':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'drive_code':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'technical_allowed_axle_load':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'legally_allowed_axle_load':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'vin_number_location':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'trailer_with_brakes':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'trailer_without_brakes':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'middleaxle_trailer_with_brakes':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'middleaxle_trailer_without_brakes':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'autonomous_trailer_with_brakes':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'trailercarrier_with_brakes':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>kg</div>
          </div>
        );
      case 'vehicleType':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'taxadditions_percentage':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>%</div>
          </div>
        );
      case 'taxaddion_until':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );

      case 'catalogprice_incl_options':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>€</div>
          </div>
        );
      case 'catalogprice_excl_options':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>€</div>
          </div>
        );
      case 'delivery_costs':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>€</div>
          </div>
        );
      case 'intrastat_goods_code':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>€</div>
          </div>
        );
      case 'approvalNumber':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>€</div>
          </div>
        );
      case 'energy_label':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
        case 'co2_rdw':
          return (
            <input
              className="form-control"
              key={this.props.type}
              value={this.props.value}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
          );
         
            case 'verbruik':
              return (
                <div className={styles.buttonLabel}>
                  <div className={styles.labelCompany}>
                    <input
                      className="form-control"
                      key={this.props.type}
                      value={this.props.value}
                      onChange={evt => this.props.setValue(evt.target.value)}
                    />
                  </div>
                  <div className={styles.decoratorLabel}>l/100km</div>
                </div>
              );

            case 'power':
              return (
                <div className={styles.buttonLabel}>
                <div className={styles.labelCompany}>
                  <input
                    className="form-control"
                    key={this.props.type}
                    value={this.props.value}
                    onChange={evt => this.props.setValue(evt.target.value)}
                  />
                </div>
                <div className={styles.decoratorLabel}>KW</div>
              </div>
              );
              case 'verbruik':
                return (
                  <div className={styles.buttonLabel}>
                  <div className={styles.labelCompany}>
                    <input
                      className="form-control"
                      key={this.props.type}
                      value={this.props.value}
                      onChange={evt => this.props.setValue(evt.target.value)}
                    />
                  </div>
                  <div className={styles.decoratorLabel}>L/100KM</div>
                </div>
      
      
               
                );
                case 'mileage':
                  return (
                    <input
                      className="form-control"
                      key={this.props.type}
                      value={this.props.value}
                      onChange={evt => this.props.setValue(evt.target.value)}
                    />
                  );

                  case 'model_info':
                    return (
                      <input
                        className="form-control"
                        key={this.props.type}
                        value={this.props.value}
                        onChange={evt => this.props.setValue(evt.target.value)}
                      />
                    );
            



      case 'euro_class':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'average_consumption_combined':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'average_highway_consumption':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'average_city_consumption':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'consumption_KwH':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'max_chargingspeed_DC':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'particulate':
        return (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                key={this.props.type}
                value={this.props.value}
                onChange={evt => this.props.setValue(evt.target.value)}
              />
            </div>
            <div className={styles.decoratorLabel}>mg/km</div>
          </div>
        );
        default:
          return ( 
          <input
          className="form-control"
          key={this.props.type}
          value={this.props.value}
          onChange={evt => this.props.setValue(evt.target.value)}
        />);
    }
  }
}

VehicleCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    value: selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
    vehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },
    deleteProperty(vehicleId, propertyName, callback) {
      dispatch(deleteVehicleProperty(vehicleId, propertyName, callback));
    },
    initiateValue() {
      dispatch(initiateNewVehicleValue(ownProps.type));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateField = compose(withConnect, withRouter)(VehicleCreateFieldComp);
